export function hasCashRegisterActivity(register) {
  return Boolean(
    (register?.cash_sales || 0) > 0
    || (register?.card_sales || 0) > 0
    || (register?.total_sales || 0) > 0
    || (register?.total_orders || 0) > 0
    || (register?.total_cancellations || 0) > 0
    || (register?.cancellation_amount || 0) > 0
  );
}

export function getCashRegisterUiState(register) {
  const status = register?.status || 'not_started';
  const hasActiveShift = Boolean(register?.has_active_shift);
  const isClosed = Boolean(register?.closed_at) || status === 'closed';
  const wasStartedWithoutActiveShift = Boolean(register?.opened_at) && !hasActiveShift && !isClosed;
  const hasActivity = hasCashRegisterActivity(register);

  if (isClosed) return 'closed';
  if (hasActiveShift) return 'open';
  if (status === 'review_required') return 'review_required';
  if (wasStartedWithoutActiveShift) return 'review_required';
  if (hasActivity) return 'review_required';
  return 'not_started';
}

export function getCashRegisterTimeRange(register) {
  if (!register?.date) return null;

  const state = getCashRegisterUiState(register);
  if (state !== 'open' && state !== 'review_required') return null;

  const fallbackOpenedAt = `${register.date}T00:00:00+00:00`;
  return {
    openedAt: register?.opened_at || fallbackOpenedAt,
    closedAt: register?.closed_at || null,
    state,
  };
}
